import * as React from "react";

function Upload2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M5.8 6.95l-.7-.707L7.938 3.4l2.841 2.842-.707.707-1.634-1.634v6.694h-1V5.315L5.8 6.95zm7.135 4.086v1.5a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-1.5h-1v1.5a1.5 1.5 0 001.5 1.5h9a1.5 1.5 0 001.5-1.5v-1.5h-1z"
  }));
}

export default Upload2Icon;